/// <amd-module name="Analytics/Common/Contracts/WorkItemTrackingDataContracts" />
/** Client-side type representating work item formatting for use by query generators
 * Note: Possible field types are at https://www.visualstudio.com/en-us/docs/work/reference/field-definition-element-reference#attributes-and-elements
 * The fields match analytics naming
 */
export interface WorkItemFieldDescriptor {
    /** Name of the field */
    FieldName: string;

    /** Type of the field */
    FieldType: string;

    /** Reference name of the field in VSTS  */
    FieldReferenceName: string;

    /** Should we use quotes to pass the value to Analytics, or pass value as-is */
    /** This value is calculated client-side. */
    UseQuotes: boolean;

    /** When making an analytics query, this is the path to use. */
    /** This value is calculated client-side. */
    AnalyticsFilterName: string;

    /** Function to figure out the value to query by from a FieldFilter */
    /** This function is calculated client-side. */
    GetAnalyticsQueryValueFunc(filter: FieldFilter): string;
}

export enum WitFieldType {
    Internal = 0,
    String = 1,
    Integer = 2,
    DateTime = 3,
    PlainText = 5,
    Html = 7,
    TreePath = 8,
    History = 9,
    Double = 10,
    Guid = 11,
    Boolean = 12,
    PicklistInteger = 14,
    PicklistString = 15
}

export namespace WiqlOperators {
    export const NotSpace = "NOT";
    export const OperatorAnd = "AND";
    export const OperatorOr = "OR";
    export const OperatorContains = "CONTAINS";
    export const OperatorNotContains = "NOT CONTAINS";
    export const OperatorContainsWords = "CONTAINS WORDS";
    export const OperatorNotContainsWords = "NOT CONTAINS WORDS";
    export const OperatorIn = "IN";
    export const OperatorNotIn = "NOT IN";
    export const OperatorEver = "EVER";
    export const OperatorNotEver = "NOT EVER";
    export const OperatorUnder = "UNDER";
    export const OperatorNotUnder = "NOT UNDER";
    export const OperatorInGroup = "IN GROUP";
    export const OperatorNotInGroup = "NOT IN GROUP";
    export const OperatorEqualTo = "=";
    export const OperatorNotEqualTo = "<>";
    export const OperatorIsEmpty = "IS EMPTY";
    export const OperatorIsNotEmpty = "IS NOT EMPTY";
    export const OperatorGreaterThan = ">";
    export const OperatorLessThan = "<";
    export const OperatorGreaterThanOrEqualTo = ">=";
    export const OperatorLessThanOrEqualTo = "<=";
    export const MacroStart = "@";
    export const MacroToday = "@today";
    export const MacroMe = "@me";
    export const MacroProject = "@project";
    export const MacroCurrentIteration = "@currentIteration";
    export const MacroTeamAreas = "@teamAreas";
    export const MacroFollows = "@follows";
    export const MacroRecentMentions = "@recentMentions";
    export const MacroMyRecentActivity = "@myRecentActivity";
    export const MacroRecentProjectActivity = "@recentProjectActivity";
    export const MacroStartOfYear = "@startOfYear";
    export const MacroStartOfMonth = "@startOfMonth";
    export const MacroStartOfWeek = "@startOfWeek";
    export const MacroStartOfDay = "@startOfDay";
}

/** Describes a filter for a field  */
export interface FieldFilter {
    /** Reference name of the field */
    fieldName: string;
    /** string representation of OData query operator. Consumer should validate against a whitelist.*/
    queryOperation: string;
    /** User-supplied query value. */
    queryValue: string;
}
